import React from 'react';
import './About.css'; // We'll create this file for the styles

function About() {
  return (
    <section className="page-content about-content">
      <div className="about-background"></div>
      {/* Add your about content here */}
    </section>
  );
}

export default About;